<template>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-xs-12">
      <button 
        v-if="logged_in_user.group_id in [1,2,3,4]"
        @click="confirmAlert()" 
        type="button" class="btn btn-warning">Stop All Alerts</button>

      <Chat></Chat>
    </div>
    <div class="col-lg-6 col-md-6 col-xs-12">
      <HavenLockWidget v-if="featureG2SecureHavenLockConnected"></HavenLockWidget>
    </div>
  </div>
</template>

<script>
import Chat from '../../components/Chat/Chat'
import HavenLockWidget from '../../components/HavenLock/HavenLockWidget'
import { mapGetters, mapActions } from 'vuex'
import router from '../../router'

export default {
  computed: {
    ...mapGetters({
      featureG2SecureHavenLockConnected: 'featureG2SecureHavenLockConnected',
      is_active_alert_event: 'isActiveAlertEvent',
      feature_g2_secure_enabled: 'featureG2SecureEnabled'
    }),
    logged_in_user: function () {
      let parsedJSON = JSON.parse(sessionStorage.getItem('logged_in_data'))
      return parsedJSON.logged_in_user
    },
  },
  methods: {
    ...mapActions(['stopActiveAlerts']),
    confirmAlert() {
      return (confirm("Are you sure you want to stop all alerts?") && this.stopActiveAlerts());
    },
    refresh() {
      if (!this.is_active_alert_event) {
        router.push({ name: 'Home' })
      }
    }
  },
  created() {
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE.G2_SECURE')
  },
  mounted () {
    this.interval = setInterval(() => { this.refresh() }, 3000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  components: { Chat, HavenLockWidget },
}
</script>

<style scoped>
.btn-warning {
  margin-bottom: 10px;
}
</style>